import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Doughnut} from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const ChartDoughnut = ({dataList}) => {

  const options = {
    plugins: {
      legend: {
        display: false, // 범례 비활성화
      },
      tooltip: {
        enabled: false, // 툴팁 비활성화
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateScale: true,
      animateRotate: true,
    },
  };

  const customPlugin = {
    id: "customDoughnutLabels",
    afterDraw: (chart) => {
      const { ctx, data } = chart;
      const { datasets } = data;

      // 데이터 순회하며 섹션 위 텍스트 그리기
      datasets[0].data.forEach((value, i) => {
        if (value > 0) { // 값이 0보다 큰 경우에만 표시
          const meta = chart.getDatasetMeta(0);
          const arc = meta.data[i];
          const center = arc.getCenterPoint(); // 섹션 중앙 좌표 가져오기
          const text = value.toString() + "%"; // % 기호 추가

          ctx.save();
          ctx.fillStyle = "white"; // 텍스트 색상
          ctx.font = "bold 13px Arial"; // 텍스트 스타일
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(text, center.x, center.y); // 텍스트 그리기
          ctx.restore();
        }
      });
    },
  };

  return (
      <div>
        {dataList.map((item, index) => {
          const data = {
            labels: ["Label 1", "Label 2", "Label 3"], // 필요 시 레이블 수정
            datasets: [
              {
                data: item.data,
                backgroundColor: item.backgroundColor,
              },
            ],
          };

          return (
              <div key={index} className="w-[7rem] h-full">
                <Doughnut data={data} options={options} plugins={[customPlugin]} />
              </div>
          );
        })}
      </div>
  );
}
export default ChartDoughnut;

